import { useState } from "react";
import { useTranslation } from "react-i18next"; // ✅ i18n import

export default function ProductsPagination({
  currentPage,
  onPageChange,
  totalPages,
}) {
  const { t } = useTranslation(); // ✅ Çeviri hook'u
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleInputSubmit = () => {
    const page = parseInt(inputValue, 10);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
    setInputValue("");
  };

  const getPageRange = () => {
    const range = [];
    let start = Math.max(1, currentPage - 5);
    let end = Math.min(totalPages, currentPage + 5);

    if (currentPage <= 6) {
      end = Math.min(totalPages, 10);
    }

    if (currentPage >= totalPages - 5) {
      start = Math.max(1, totalPages - 9);
    }

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    return range;
  };

  const renderPageButtons = () => {
    const range = getPageRange();
    const showMiddleEllipsis = totalPages > 15;

    return (
      <div className="d-flex gap-1 align-items-center">
        {currentPage > 6 && (
          <>
            <button
              onClick={() => onPageChange(1)}
              className={`btn ${currentPage === 1 ? 'btn-primary' : 'admin-hover'} d-flex align-items-center justify-content-center`}
              style={{ width: "40px", height: "40px" }}
            >
              1
            </button>
            {showMiddleEllipsis && (
              <span className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "40px", cursor: "default" }}>
                ...
              </span>
            )}
          </>
        )}
        {range.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`btn ${currentPage === page ? 'btn-primary' : 'admin-hover'} d-flex align-items-center justify-content-center`}
            style={{ width: "40px", height: "40px" }}
          >
            {page}
          </button>
        ))}
        {currentPage < totalPages - 5 && (
          <>
            {showMiddleEllipsis && (
              <span className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "40px", cursor: "default" }}>
                ...
              </span>
            )}
            <button
              onClick={() => onPageChange(totalPages)}
              className={`btn ${currentPage === totalPages ? 'btn-primary' : 'admin-hover'} d-flex align-items-center justify-content-center`}
              style={{ width: "40px", height: "40px" }}
            >
              {totalPages}
            </button>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mt-3">
      <div className="d-flex gap-1 align-items-center">
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="btn btn-primary d-flex align-items-center justify-content-center"
          style={{ width: "40px", height: "40px" }}
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        {renderPageButtons()}
        <button
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="btn btn-primary d-flex align-items-center justify-content-center"
          style={{ width: "40px", height: "40px" }}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
      <div className="d-flex gap-2 align-items-center">
        <div className="input-group" style={{ width: "150px" }}>
          <input
            type="number"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleInputSubmit();
              }
            }}
            onBlur={handleInputSubmit}
            min="1"
            max={totalPages}
            placeholder={t("sahypa")} // ✅ Çeviri eklendi
            className="form-control form-control-sm"
            style={{ textAlign: "center" }}
          />
        </div>
        <span className="text-muted">{t("jemi")}:</span> {/* ✅ Çeviri eklendi */}
        <div className="badge bg-secondary">{totalPages}</div>
      </div>
    </div>
  );
}